module.exports = __webpack_public_path__ + "img/20191008160138896.96bd949a.jpg";